import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

import type { GcsFolderImportDisposition } from '../types/uploads';

export const MAX_SOURCE_IMPORT_URLS = 100;
export const GCS_FOLDER_SELECTION_LIMIT = 100;

/** Stable backend conflict messages for `POST /source-imports`. */
export const SOURCE_IMPORT_DUPLICATE_SOURCE_ERROR =
  'this source is already imported (or importing) by you';
export const SOURCE_IMPORT_DUPLICATE_ID_ERROR = 'duplicate import id';

export const GCS_FOLDER_DISPOSITION_LABELS: Record<GcsFolderImportDisposition, MessageDescriptor> =
  {
    created: msg`Import started`,
    skipped_existing: msg`Already imported`,
    source_changed: msg`Changed after scan`,
    invalid_media: msg`Invalid MCAP`,
    source_missing: msg`Source missing`,
    source_forbidden: msg`Access denied`,
    temporarily_unavailable: msg`Temporarily unavailable`,
  };

export const GCS_FOLDER_DISPOSITION_VARIANTS: Record<
  GcsFolderImportDisposition,
  'success' | 'secondary' | 'warning' | 'destructive'
> = {
  created: 'success',
  skipped_existing: 'secondary',
  source_changed: 'warning',
  invalid_media: 'destructive',
  source_missing: 'destructive',
  source_forbidden: 'destructive',
  temporarily_unavailable: 'warning',
};

export const SOURCE_IMPORT_SHARE_PRINCIPAL_BY_ENV = {
  development: 'vision-lab-drive-dev@linewise.io',
  testing: 'vision-lab-drive-testing@linewise.io',
  production: 'vision-lab-drive-product@linewise.io',
} as const;
